import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-wr" }
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = { class: "default-form" }
const _hoisted_4 = { class: "buttons-section" }
const _hoisted_5 = { class: "input-wr borrow-calculator" }
const _hoisted_6 = ["onChange", "value"]
const _hoisted_7 = { class: "input-wr no-margin" }
const _hoisted_8 = { class: "input dropdown-input" }
const _hoisted_9 = { class: "buttons-section" }
const _hoisted_10 = { class: "input-wr borrow-calculator" }
const _hoisted_11 = ["onChange", "value"]
const _hoisted_12 = { class: "input-wr no-margin" }
const _hoisted_13 = { class: "input dropdown-input" }
const _hoisted_14 = { class: "buttons-section" }
const _hoisted_15 = { class: "input-wr borrow-calculator" }
const _hoisted_16 = ["onChange", "value"]
const _hoisted_17 = { class: "input-wr no-margin" }
const _hoisted_18 = { class: "input dropdown-input" }
const _hoisted_19 = { class: "buttons-section" }
const _hoisted_20 = { class: "input-row" }
const _hoisted_21 = { class: "input-wr" }
const _hoisted_22 = ["onChange", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "tab-title" }, "General living expenses (ongoing)", -1)),
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "tab-subtitle" }, "Includes groceries, bills etc.", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              class: "input",
              onChange: (e) => $setup.updateFormInput(e, $setup.BorrowCalculatorFields.EXPENSE_1),
              type: "text",
              value: $setup.props.form?.Expense1,
              placeholder: "Living expenses"
            }, null, 40, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_8, _toDisplayString($setup.getPeriodicityKey($setup.props.form?.Expense1Fre)), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_1_FRE, $setup.Periodicity.YEARLY)))
                  }, "yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_1_FRE, $setup.Periodicity.HALF_YEARLY)))
                  }, "half yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_1_FRE, $setup.Periodicity.MONTHLY)))
                  }, "monthly"),
                  _createElementVNode("li", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_1_FRE, $setup.Periodicity.FORTNIGHTLY)))
                  }, "fortnightly")
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "tab-title" }, "Rent", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("input", {
              class: "input",
              onChange: (e) => $setup.updateFormInput(e, $setup.BorrowCalculatorFields.EXPENSE_4),
              type: "text",
              value: $setup.props.form?.Expense4,
              placeholder: "Rent"
            }, null, 40, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_13, _toDisplayString($setup.getPeriodicityKey($setup.props.form?.Expense4Fre)), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_4_FRE, $setup.Periodicity.YEARLY)))
                  }, "yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_4_FRE, $setup.Periodicity.HALF_YEARLY)))
                  }, "half yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_4_FRE, $setup.Periodicity.MONTHLY)))
                  }, "monthly"),
                  _createElementVNode("li", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_4_FRE, $setup.Periodicity.FORTNIGHTLY)))
                  }, "fortnightly")
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "tab-title" }, "Loan repayments", -1)),
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "tab-subtitle" }, "Includes car loans, personal loans, home loans etc", -1)),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              class: "input",
              onChange: (e) => $setup.updateFormInput(e, $setup.BorrowCalculatorFields.EXPENSE_2),
              type: "text",
              value: $setup.props.form?.Expense2,
              placeholder: "Loan repayments"
            }, null, 40, _hoisted_16)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_18, _toDisplayString($setup.getPeriodicityKey($setup.props.form?.Expense2Fre)), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_2_FRE, $setup.Periodicity.YEARLY)))
                  }, "yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_2_FRE, $setup.Periodicity.HALF_YEARLY)))
                  }, "half yearly"),
                  _createElementVNode("li", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_2_FRE, $setup.Periodicity.MONTHLY)))
                  }, "monthly"),
                  _createElementVNode("li", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.EXPENSE_2_FRE, $setup.Periodicity.FORTNIGHTLY)))
                  }, "fortnightly")
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "tab-title" }, "Credit card limits", -1)),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "tab-subtitle" }, "This is the maximum credit amounts you can borrow", -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("input", {
                class: "input",
                onChange: (e) => $setup.updateFormInput(e, $setup.BorrowCalculatorFields.EXPENSE_3),
                type: "text",
                value: $setup.props.form?.Expense3,
                placeholder: "Credit card limits"
              }, null, 40, _hoisted_22)
            ])
          ])
        ])
      ])
    ])
  ]))
}